module.exports = __webpack_public_path__ + "static/media/el.9920bf7a.png";